import ViewController from "core/views/view.controller";
import {DataLoadingEvent} from "core/interceptors/loading.interceptor";

export default class LoadingIndicatorCtrl extends ViewController {
    static $inject = ['$scope', '$element', '$timeout', '$ionicPopup', '$translate', '$loadingIndicator'];

    constructor() {
        super(...arguments);
        this.errorTitle = null;
        this.errorMessage = null;
        this.minDuration = 1000;
        this.startTime = 0;
        this.dataLoadingErrorOpen = false;
    }

    $onInit() {
        var self = this;

        if (!this.errorTitle) {
            this.$translate('LOADING_ERROR_TITLE').then((errorTitle)=> {
                self.errorTitle = errorTitle;
            })
        }

        if (!this.errorMessage) {
            this.$translate('LOADING_ERROR_MESSAGE').then((errorMessage)=> {
                self.errorMessage = errorMessage;
            })
        }

        this.$scope.$on(DataLoadingEvent.Start, function () {
            if(self.$loadingIndicator.enabled) {
                self.showLoadingIndicator();
            }
        });

        this.$scope.$on(DataLoadingEvent.Stop, function () {
            if(self.$loadingIndicator.enabled) {
                self.hideLoadingIndicator();
            }
        });

        this.$scope.$on(DataLoadingEvent.Error, function () {
            if (self.$loadingIndicator.showErrorMessage && !self.dataLoadingErrorOpen) {
                self.dataLoadingErrorOpen = true;

                self.$ionicPopup.alert({
                    title: self.errorTitle,
                    template: self.errorMessage,
                    okType: 'button button-block button-balanced button-outline'
                }).then(function () {
                    self.dataLoadingErrorOpen = false;
                }).catch(()=> {
                    self.dataLoadingErrorOpen = false;
                });
            }
        });
    }

    showLoadingIndicator() {
        this.startTime = new Date().getTime();
        this.$element.removeClass('inactive');
        this.$element.addClass('active');
    }

    hideLoadingIndicator() {
        var pendingDuration = this.minDuration - (new Date().getTime() - this.startTime);
        var self = this;

        this.$timeout(function () {
            self.$element.addClass('inactive');
            self.$element.removeClass('active');
        }, pendingDuration > 0 ? pendingDuration : 0);
    }
}



// WEBPACK FOOTER //
// ./src/modules/core/components/loading-indicator/loading-indicator.controller.js